import { render, staticRenderFns } from "./TransitionDetails.vue?vue&type=template&id=0799f35c&"
import script from "./TransitionDetails.vue?vue&type=script&lang=js&"
export * from "./TransitionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports